import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const AssetFormAssurance = ({
  catalogs = {},
  errors = {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  t = () => {},
  values = {},
}) => {
  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.assurance')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.Checkbox
          name="insurable"
          className="icheckbox_flat-blue"
          onChange={handleValueChange}
          checked={values.insurable}
          label={t('assets.fields.insurable')}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._insuranceCarrier) || {}}
          isLoading={isLoading}
          name={'insuranceCarrier'}
          label={t('assets.fields.insuranceCarrier')}
          handleChange={handleValueChange}
          t={t}
          value={values._insuranceCarrier && values._insuranceCarrier.id}
        >
          {catalogs.insuranceCarrier &&
            catalogs.insuranceCarrier
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.insurancePolicy) || {}}
          name={'insurancePolicy'}
          label={t('assets.fields.insurancePolicy')}
          handleChange={handleValueChange}
          t={t}
          value={values.insurancePolicy}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.insurancePercent) || {}}
          name={'insurancePercent'}
          label={t('assets.fields.insurancePercent')}
          handleChange={handleValueChange}
          t={t}
          value={values.insurancePercent}
        />
      </div>
    </div>
  );
};

export default translate()(AssetFormAssurance);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormAssurance.js